firebird.factory('capabilityService', [
    '$rootScope',
    'logService',
    function ($rootScope, logService) {
        const logger = new LogServiceWrapper(logService, 'capabilityService');

        var capabilities = {},
            service = {
                hasCapability: hasCapability
            };

        $rootScope.$on('user-capabilities', onCapabilityUpdated);

        return service;

        function onCapabilityUpdated(evt, cap) {
            if (cap) {
                capabilities = cap;
                $rootScope.$broadcast('user-capability-updated');
            }
        }

        function hasCapability(capability) {
            if (!capabilities || Object.keys(capabilities).length === 0) {
                return false;
            }
            if (typeof capabilities[capability] === 'undefined') {
                logger.error('hasCapability', 'does not have capability', capability);
                return false;
            }
            return capabilities[capability];
        }
    }
]);
